export const LOAD_OFFER_INSURANCE_STARTED = "LOAD_OFFER_INSURANCE_STARTED";
export const LOAD_OFFER_INSURANCE_SUCCEEDED = "LOAD_OFFER_INSURANCE_SUCCEEDED";
export const LOAD_OFFER_INSURANCE_FAILED = "LOAD_OFFER_INSURANCE_FAILED";

export const LOAD_OFFER_INSURANCE_COMPANIES_STARTED = "LOAD_OFFER_INSURANCE_COMPANIES_STARTED";
export const LOAD_OFFER_INSURANCE_COMPANIES_SUCCEEDED = "LOAD_OFFER_INSURANCE_COMPANIES_SUCCEEDED";
export const LOAD_OFFER_INSURANCE_COMPANIES_FAILED = "LOAD_OFFER_INSURANCE_COMPANIES_FAILED";

export const LOAD_OFFER_INSURANCE_PRODUCTS_STARTED = "LOAD_OFFER_INSURANCE_PRODUCTS_STARTED";
export const LOAD_OFFER_INSURANCE_PRODUCTS_SUCCEEDED = "LOAD_OFFER_INSURANCE_PRODUCTS_SUCCEEDED";
export const LOAD_OFFER_INSURANCE_PRODUCTS_FAILED = "LOAD_OFFER_INSURANCE_PRODUCTS_FAILED";

export const SAVE_OFFER_INSURANCE_STARTED = "SAVE_OFFER_INSURANCE_STARTED";
export const SAVE_OFFER_INSURANCE_SUCCEEDED = "SAVE_OFFER_INSURANCE_SUCCEEDED";
export const SAVE_OFFER_INSURANCE_FAILED = "SAVE_OFFER_INSURANCE_FAILED";

export const CANCEL_OFFER_INSURANCE_CHANGES = "CANCEL_OFFER_INSURANCE_CHANGES";
